import { listStages } from "../../content/stages.js";
import type { HourlyBucket, HourlyMetric } from "./HourlyChart.js";
import { stageColor } from "./stageColors.js";

type Props = { bucket: HourlyBucket; metric: HourlyMetric; onClose: () => void };

export function HourlyDetailPanel({ bucket, metric, onClose }: Props) {
  const stages = listStages();
  const entries = stages
    .map((stage, index) => ({ stage, color: stageColor(index), count: bucket.stages.get(stage.id) ?? 0 }))
    .filter((entry) => entry.count > 0);
  const total = metric === "stages" ? entries.reduce((sum, entry) => sum + entry.count, 0) : bucket.playerCount;

  return (
    <div className="analytics-chart-detail" role="status">
      <div className="analytics-chart-detail-head">
        <b>{bucket.hour.replace("T", " ")}</b>
        <button type="button" aria-label="内訳を閉じる" onClick={onClose}>×</button>
      </div>
      {metric === "stages"
        ? entries.map((entry) => (
            <span key={entry.stage.id}><i style={{ background: entry.color }} />{entry.stage.name}<strong>{entry.count}</strong></span>
          ))
        : <span>ユニークユーザー<strong>{bucket.playerCount}</strong></span>}
      <em>合計 {total}</em>
    </div>
  );
}
